import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import { sortReplies } from '@btime/helpers'
import React from 'react'

import { formsClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useFormState = () => React.useContext(Context)
export const useForm = () => useFormState()?.form

export const useQuestions = () => {
  const questions = pathOr([], ['checklist', 'questions'], useForm())
  return sortReplies(questions)
}

const QUERY = gql`
  query Form($id: ID) {
    form(id: $id) {
      id
      name
      description
      access
      repliesCount
      insertedAt
      checklistId
      checklist {
        id
        questions {
          id
          name
          reference
          parentReference
          ordination
          categoryOrdination
          options {
            id
            name
            ordination
          }
          category {
            id
            name
          }
          type {
            id
            name
          }
        }
      }
    }
  }
`

const FormLoader = ({ children, id }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: formsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default FormLoader
